import {
  Contribution,
  ContributionClassName,
  ContributionClassRolesDDL,
} from 'types/contribution';
import pluralize from 'pluralize';
import { ContributionsListComponentProps } from './types';

export const getChipRoleLabel = (
  contribution: Partial<Contribution>,
  contributionRoles?: ContributionClassRolesDDL
) => {
  if (contributionRoles) {
    if (contribution.roleDetail) {
      return (
        contributionRoles[contribution.roleDetail]?.name ||
        contribution.roleDetail
      );
    }
    if (contribution.role) {
      return contributionRoles[contribution.role]?.name || contribution.role;
    }
  }
  return 'No Role Selected';
};

export const pluralizeClassRole = (role: string) => {
  pluralize.addUncountableRule(ContributionClassName.PRODUCTION);

  return pluralize.plural(role);
};

export const areComponentPropsEqual = (
  prev: ContributionsListComponentProps,
  current: ContributionsListComponentProps
) =>
  !(
    prev.loading !== current.loading ||
    prev.canAddContribution !== current.canAddContribution ||
    JSON.stringify(prev.contributionClassesAndRoles) !==
      JSON.stringify(current.contributionClassesAndRoles) ||
    JSON.stringify(prev.contributions) !== JSON.stringify(current.contributions)
  );

const OPTIONS_SIZE = 60;
const AVATAR_SIZE = 52;

const getColumnSize = (percent: number, totalWidth?: number) => {
  if (!totalWidth) {
    return undefined;
  }
  return (totalWidth - AVATAR_SIZE - OPTIONS_SIZE) * percent;
};

export const getColumns = (totalWidth?: number) => [
  {
    accessorKey: 'avatar',
    accessory: true,
    size: AVATAR_SIZE,
  },
  {
    accessorKey: 'name',
    header: 'Name',
    enableResizing: true,
    size: getColumnSize(0.5, totalWidth),
    sx: { pl: 0 },
    minSize: 60,
  },
  {
    accessorKey: 'role',
    header: 'Role',
    enableResizing: true,
    size: getColumnSize(0.5, totalWidth),
    minSize: 50,
  },
  {
    accessorKey: 'gap',
    size: 0,
  },
  {
    accessorKey: 'options',
    size: OPTIONS_SIZE,
    contextMenu: true,
  },
];
